import request from "root/js/request";

export const getIncomeTermsExport = async ({ cabinet_id, marketplace, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/income_terms/export/",
    method: "get",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
